// extracted by mini-css-extract-plugin
module.exports = {"infoButton":"animation-module--infoButton--1RXZT","fadeIn":"animation-module--fadeIn--2WbMS"};